import React from "react";
import PropTypes from "prop-types";
import Snackbar from "react-md/lib/Snackbars";

const Message = ({ onClearMessage, message }) => (
  <Snackbar
    toasts={message ? [{ text: message }] : []}
    autohide
    onDismiss={onClearMessage}
  />
);

Message.propTypes = {
  message: PropTypes.string,
  onClearMessage: PropTypes.func.isRequired
};

Message.defaultProps = {
  message: null
};

export default Message;



// WEBPACK FOOTER //
// ./src/customer/components/Message/Message.jsx